import Base64 from 'assets/js/util/base64';

const allowedEmails = {
  kw: [
    '752363@kw.com',
    'misha.kittilson@kw.com',
    '327625@kw.com',
    'donnie@kw.com',
    '264365@kw.com',
    'jessica.campbell@kw.com',
    '755591@kw.com',
    '2004351014@kw.com'
  ]
};
/**
 * It should show the switch editor button if the user is not a workspace user
 * unless the user's email ends with @desygner.com
 * @returns {boolean}
 */
export function shouldShowSwitchEditorButton () {
  const encodedEmail = INKIVE.C.USER.email;
  if (!encodedEmail) return false;

  const userEmail = Base64.decode(encodedEmail);

  // const isDesygnerProject = INKIVE.Helpers.isDesygnerProject();
  const isAllowedWorkspace = INKIVE.C.SHOW_NEW_EDITOR;
  const isDesygnerStaff = /@(desygner|webrand|fluer)\.com$/.test(userEmail);

  const domain = INKIVE.C.WHITE_LABEL_CONFIGURATION.domain;
  const isKw = INKIVE.C.WHITE_LABEL_CONFIGURATION.domain === 'kw' || INKIVE.C.WHITE_LABEL_CONFIGURATION.parent_domain === 'kw';
  const isAllowedEmails = allowedEmails[isKw ? 'kw' : domain];

  return [
    // isDesygnerProject,
    isDesygnerStaff,
    isAllowedWorkspace,
    isAllowedEmails && isAllowedEmails.includes(userEmail)
  ].some(Boolean);
}
